/**
 * Полоса «поставьте приложение из Play» — только для Android в браузере.
 *
 * **Зачем.** На телефоне приложение из магазина заметно лучше сайта: там
 * настоящие уведомления (а они у нас единственный измеренный рычаг возврата —
 * 43% против 20%), реклама за звёзды и покупки. Замерено 2026-09-07: из
 * пришедших за две недели с Android до расклада дошли 71%, а из пришедших в
 * браузер — 2%. Человека с Android разумнее сразу отправить туда, где он
 * останется.
 *
 * **Показываем СРАЗУ, а не после первого расклада.** Это осознанная разница с
 * `InstallOffer`: тот предлагает добавить сайт на экран и обещает звёзды, и
 * его смысл понятен только тому, кто уже что-то увидел. Здесь наоборот —
 * человек ещё ничего не вложил в браузерную версию, и чем раньше он окажется в
 * приложении, тем меньше потеряет.
 *
 * **Одна полоса, а не две.** На Android предложение поставить PWA не
 * показывается вовсе (см. `InstallOffer`): два предложения установки рядом —
 * это выбор, которого человек не просил, и оба он закроет.
 *
 * **Закрыл — не возвращаемся.** Полоса не про награду, а про удобство;
 * настаивать на удобстве, от которого отказались, незачем.
 */
import { useState } from 'react'

import { isAndroidBrowser, PLAY_URL } from '../lib/android'
import { track } from '../lib/analytics'
import { useSirr } from '../store'

const HIDDEN_KEY = 'sirr_get_app_hidden'

export function GetApp() {
  const { t } = useSirr()
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(HIDDEN_KEY) === '1'
    } catch {
      return false
    }
  })

  if (hidden || !isAndroidBrowser()) return null

  const close = () => {
    setHidden(true)
    try {
      localStorage.setItem(HIDDEN_KEY, '1')
    } catch {
      /* приватный режим — переживём, полоса вернётся при следующем заходе */
    }
  }

  return (
    <div className="getapp">
      <div className="getapp__text">
        <strong>{t('getApp')}</strong>
        <span>{t('getAppSub')}</span>
      </div>
      <a
        className="getapp__go"
        href={PLAY_URL}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          track('to_play')
          // Полосу убираем: человек ушёл в Play, и по возвращении она была бы
          // предложением сделать сделанное.
          close()
        }}
      >
        {t('getAppBtn')}
      </a>
      <button className="getapp__close" onClick={close} aria-label="×">
        ×
      </button>
    </div>
  )
}
